import { render, staticRenderFns } from "./dashboardView.vue?vue&type=template&id=1e15f962&scoped=true&"
import script from "./dashboardView.vue?vue&type=script&lang=js&"
export * from "./dashboardView.vue?vue&type=script&lang=js&"
import style0 from "./dashboardView.vue?vue&type=style&index=0&id=1e15f962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e15f962",
  null
  
)

export default component.exports